// Footer.js
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <p>© Propertunity {currentYear}</p>
      
    </footer>
  );
}

export default Footer;
